module.exports = __webpack_public_path__ + "img/background-modal.8039496d.svg";